import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getCurrency } from 'core/utils/cultures/unit'
import { injectIntl } from 'react-intl'
import { Slider } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const CustomSlider = styled(Slider)`
  .ant-slider-mark-text {
    font-size: ${font.size.sm};
  }
`

const SliderWrapper = styled.div`
  padding: 0 20px 5px;
`

const Price = props => {
  const [currentValues, setCurrentValues] = useState([])

  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { priceMin, priceMax } = filters
  const pricesList = filtersDatas.prices

  const formatter = value => {
    const intlValue = intl.formatNumber(value)

    return `${intlValue} ${getCurrency()}`
  }

  const marks = {}
  const maxValue = currentValues[1]
  const minValue = currentValues[0]

  marks[maxValue] = formatter(maxValue)
  marks[minValue] = formatter(minValue)

  const onChange = value => {
    setCurrentValues(value)
  }

  const handleOnChangeFiltre = item => {
    const [min, max] = item

    const extendedFiltersValues = {
      ...filters,
      priceMax: max,
      priceMin: min
    }

    onChangeFilter(extendedFiltersValues)
  }

  useEffect(() => {
    const values = []

    if (pricesList) {
      const maxVal = priceMax || pricesList.max
      const minVal = priceMin || pricesList.min

      values[0] = minVal
      values[1] = maxVal
    }

    setCurrentValues(values)
  }, [])

  return (
    <div data-test="component-stock-vehicles-list-filters-price">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-price-title'
        })}
        data-test="stock-vehicles-list-filters-price-title"
      />
      <SliderWrapper>
        {pricesList && (
          <CustomSlider
            defaultValue={currentValues}
            max={pricesList.max}
            min={pricesList.min}
            step={pricesList.step}
            range
            marks={marks}
            onAfterChange={value => handleOnChangeFiltre(value)}
            onChange={value => onChange(value)}
            tooltipVisible={false}
            data-test="stock-vehicles-list-filters-price-slider"
          />
        )}
      </SliderWrapper>
    </div>
  )
}

Price.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Price)
